<nav #navbar class="navbar navbar-expand-lg navbar-sgc">
  <div class="container-fluid navbar-sgc-container">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button mat-icon-button (click)="minimizeSidebar()" class="navbar-minimize-btn">
          <i class="material-icons visible-on-sidebar-regular">menu</i>
          <i class="material-icons visible-on-sidebar-mini">menu_open</i>
        </button>
      </div>
      <span class="navbar-title">{{ getTitle() }}</span>
    </div>
    <button mat-button [matMenuTriggerFor]="userMenu" class="navbar-user-trigger">
      <div class="navbar-user-block">
        <span class="navbar-user-name">{{ user.fullname }}</span>
        <div class="navbar-avatar">{{ user.shortname | slice:0:2 | uppercase }}</div>
        <mat-icon class="navbar-user-chevron">expand_more</mat-icon>
      </div>
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before">
      <button mat-menu-item routerLink="/profile">
        <mat-icon>person</mat-icon>
        <span>Mi perfil</span>
      </button>
      <button mat-menu-item (click)="logOut()" class="menu-item-logout">
        <mat-icon>logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </mat-menu>
  </div>
</nav>
